module.exports = __webpack_public_path__ + "static/Logo_Alt@2x-caf7a3887d6b4c7760cf92c82e944d86.svg";